<template>
    <div class="clients">
    <v-dialog v-model="dialogDelete" max-width="290">
        <v-card>
            <v-card-title class="headline">
                ¿Eliminar Planta Destino?
            </v-card-title>

            <v-card-text>
                Esta acción no se puede deshacer
            </v-card-text>

            <v-card-actions>
                <v-btn
                        color="primary"
                        @click="dialogDelete = false"
                >
                    No
                </v-btn>
                <v-spacer/>
                <v-btn
                        color="primary"
                        :loading="loadingAddClient"
                        @click="deleteClient"
                >
                    {{$t('Si')}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
    <!-- Diálogo con formulario -->
    <v-dialog v-model="dialogClientes" max-width="600px">
      <v-card>
        <v-card-title class="primary white--text">
          <v-icon left dark>location_on</v-icon>
          <span class="headline">{{ update ? 'Editar' : 'Nueva' }} Planta Destino</span>
        </v-card-title>
        <v-card-text class="pt-4">
          <v-form ref="form" v-model="valid" lazy-validation>
            <!-- Empresa Propietaria -->
            <v-autocomplete
              v-model="cliente.owner_empresa"
              :items="empresas"
              :loading="isLoading_empresas"
              :search-input.sync="searchEmpresa"
              item-text="name"
              item-value="id"
              :label="'Empresa'"
              :placeholder="'Buscar empresa...'"
              color="primary"
              prepend-icon="business"
              clearable
              :error-messages="errores.owner_empresa"
            >
              <template v-slot:selection="data">
                <v-chip
                  :selected="data.selected"
                  class="chip--select-multi"
                  color="primary"
                  text-color="white"
                >
                  <v-avatar>
                    <v-icon>business</v-icon>
                  </v-avatar>
                  {{ data.item.name }}
                </v-chip>
              </template>
              <template v-slot:item="data">
                <v-list-tile-avatar>
                  <v-icon>business</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{ data.item.name }}</v-list-tile-title>
                  <v-list-tile-sub-title>{{ data.item.email }}</v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
              <template v-slot:no-data>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-list-tile-title>
                      Escribe para buscar empresas en la comunidad Intrare
                    </v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
              </template>
            </v-autocomplete>

            <v-divider class="my-3"></v-divider>

            <!-- N° de Planta -->
            <v-text-field
              v-model="cliente.code"
              label="Número de identificación *"
              :rules="[v => !!v || 'El número de identificación es requerido']"
              color="primary"
              prepend-icon="tag"
              :error-messages="errores.code"
            ></v-text-field>

            <!-- Nombre de la Planta -->
            <v-text-field
              v-model="cliente.name"
              label="Nombre de Planta Destino *"
              :rules="[v => !!v || 'El nombre es requerido']"
              color="primary"
              prepend-icon="location_city"
            ></v-text-field>

            <!-- Domicilio -->
            <v-text-field
              v-model="cliente.address"
              label="Dirección *"
              :rules="[v => !!v || 'La dirección es requerida']"
              color="primary"
              prepend-icon="place"
            ></v-text-field>

            <!-- Email (opcional) -->
            <v-text-field
              v-model="cliente.email"
              label="Email de Contacto (opcional)"
              type="email"
              color="primary"
              prepend-icon="email"
              :error-messages="errores.email"
            ></v-text-field>

            <!-- Tiempo de carga -->
            <v-text-field
              v-model="cliente.loading_time_minutes"
              label="Tiempo de Carga (minutos) *"
              type="number"
              min="1"
              :rules="[v => !!v || 'El tiempo es requerido']"
              color="primary"
              prepend-icon="schedule"
            ></v-text-field>
          </v-form>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" flat @click="dialogClientes = false">
            {{ $t('cancelar') }}
          </v-btn>
          <v-btn v-if="update" color="primary" :loading="loadingAddClient" @click="updateClient">
            <v-icon left>save</v-icon>
            {{ $t('modificar') }}
          </v-btn>
          <v-btn
            v-else
            color="primary"
            :loading="loadingAddClient"
            @click="createClient"
        >
            <v-icon left>add</v-icon>
            {{ $t('guardar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        <h2 class="subheading grey--text">Plantas Destino</h2>
        <v-container class="my-5">
            <!--     Dialog Formulario Alta      -->
            <v-layout align-center justify-center fill-height>
                <v-btn
                        class="align-self-end"
                        color="primary"
                        @click="abrirDialogClientes">
                        <v-icon left>add</v-icon>
                        Nueva Planta Destino
                </v-btn>
            </v-layout>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        Plantas Destino
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loadingClients"
                            :items="clients"
                            :search="search"
                            class="elevation-1"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :no-data-text="'No hay plantas destino registradas'"
                            :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        class="mr-2"
                                        @click="llenarDialogClientes(props.item), update = true, id_update = props.item.id"
                                    >
                                    edit
                                </v-icon>
                                <v-icon
                                        medium
                                        color="red"
                                        @click="dialogDelete = true, id_update = props.item.id"
                                >
                                    delete
                                </v-icon>
                            </td>
                            <td>{{ props.item.code }}</td>
                            <td>{{ props.item.name }}</td>
                            <td>
                                <v-chip v-if="props.item.owner_empresa_detail" color="primary" text-color="white" small>
                                    <v-avatar>
                                        <v-icon small>business</v-icon>
                                    </v-avatar>
                                    {{ props.item.owner_empresa_detail.name }}
                                </v-chip>
                                <span v-else class="grey--text">Sin asignar</span>
                            </td>
                            <td>{{ props.item.address }}</td>
                            <td>{{ props.item.loading_time_minutes }} min</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            Plantas {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import VuePhoneNumberInput from 'vue-phone-number-input'
    import 'vue-phone-number-input/dist/vue-phone-number-input.css'

    Vue.use(VeeValidate)
    Vue.component('vue-phone-number-input', VuePhoneNumberInput)
    import { mapState, mapGetters} from 'vuex'

    export default {
        name: "clients",
        data: () => ({
            clients: [],
            update:false,
            id_update: 0,
            errores: [],
            dialogClientes: false,
            search: '',
            headers: [],
            loadingClients: false,
            loading: false,
            valid: true,
            cliente: {
                id: '',
                name: '',
                address: '',
                loading_time_minutes: '',
                email: '',
                owner_empresa: null
            },
            loadingAddClient: false,
            id_empresa: '',
            dialogDelete: false,
            isLoading: false,
            empresas: [],
            searchEmpresa: null,
            isLoading_empresas: false
        }),
        watch: {
            searchEmpresa(val) {
                if (val && val.length > 2) {
                    this.queryEmpresas(val)
                }
            }
        },
        beforeUpdate (){
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'left',
                    sortable: false,
                    value: 'update'
                },
                {
                    text: 'Código',
                    align: 'left',
                    sortable: true,
                    value: 'code'
                },
                {
                    text: 'Nombre de Planta',
                    align: 'left',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: 'Empresa',
                    align: 'left',
                    sortable: true,
                    value: 'owner_empresa_detail.name'
                },
                {
                    text: 'Dirección',
                    align: 'left',
                    sortable: true,
                    value: 'address'
                },
                {
                    text: 'Tiempo de Carga',
                    align: 'left',
                    sortable: true,
                    value: 'loading_time_minutes'
                }
            ]
        },
        created: function () {
            this.get_extra_data()
        },
        computed: {
            ...mapState(['language']),
            ...mapGetters(['getProfile'])
        },
        methods: {
            get_extra_data (){
                this.loadingClients = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/auth/me',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.id_empresa = response.data.id_company
                        this.getClients()
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            queryEmpresas(val) {
                this.isLoading_empresas = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/empresas/filter?search=' + val,
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.empresas = response.data
                        this.isLoading_empresas = false
                    })
                    .catch(error => {
                        console.log(error)
                        this.isLoading_empresas = false
                    })
            },
            getClients () {
                this.loadingClients = true
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/clients/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    params: {
                        empresa: this.id_empresa,
                        is_active: true
                    }
                };
                axios(config)
                    .then(response => {
                        this.clients = response.data
                        this.loadingClients = false
                    })
                    .catch(error => {
                        this.loadingClients = false
                        console.log(error)
                    })
            },
            abrirDialogClientes() {
                this.update = false
                this.id_update = 0
                this.errores = []
                this.dialogClientes = true
                this.$refs.form.resetValidation()
                this.limpiarFormulario()
            },
            llenarDialogClientes(item) {
                this.errores = []
                this.dialogClientes = true
                this.cliente = {
                    code: item.code,
                    name: item.name,
                    address: item.address,
                    loading_time_minutes: item.loading_time_minutes,
                    email: item.email || '',
                    owner_empresa: item.owner_empresa || null
                }
                // Si tiene empresa propietaria, agregarla a la lista para que se muestre
                if (item.owner_empresa_detail) {
                    this.empresas = [item.owner_empresa_detail]
                }
            },
            createClient() {
                if (this.$refs.form.validate()) {
                    this.errores = []
                    if (this.$refs.form.validate()) {
                        this.loadingAddClient = true
                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/clients/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                code: this.cliente.code,
                                name: this.cliente.name,
                                address: this.cliente.address,
                                loading_time_minutes: this.cliente.loading_time_minutes,
                                email: this.cliente.email || null,
                                owner_empresa: this.cliente.owner_empresa || null
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loadingAddClient = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', 'Planta destino creada exitosamente')
                                this.getClients()
                                this.limpiarFormulario()
                                this.dialogClientes = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loadingAddClient = false
                                if(error.response && error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }
            },
            updateClient() {
                if (this.$refs.form.validate()) {
                    this.errores = []
                    if (this.$refs.form.validate()) {
                        this.loadingAddClient = true
                        const config = {
                            method: 'put',
                            url: 'https://empresa-service.intrare.app/clients/' + this.id_update + '/',
                            headers: {
                                'Content-Type': 'application/json',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: {
                                code: this.cliente.code,
                                name: this.cliente.name,
                                address: this.cliente.address,
                                loading_time_minutes: this.cliente.loading_time_minutes,
                                email: this.cliente.email || null,
                                owner_empresa: this.cliente.owner_empresa || null
                            }
                        };
                        axios(config)
                            .then(ok => {
                                this.loadingAddClient = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', 'Planta destino actualizada exitosamente')
                                this.getClients()
                                this.limpiarFormulario()
                                this.dialogClientes = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loadingAddClient = false
                                if(error.response && error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }
            },
            deleteClient () {
                this.errores = []
                this.loadingAddClient = true
                const config = {
                    method: 'delete',
                    url: 'https://empresa-service.intrare.app/clients/' + this.id_update + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    }
                }
                axios(config)
                    .then(ok => {
                        this.loadingAddClient = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('client_data_deleted'))
                        this.getClients()
                        this.dialogDelete = false
                        this.limpiarFormulario()
                        setTimeout(this.clear, 3000);
                    })
                    .catch(error => {
                        this.loadingAddClient = false
                        if(error.response && error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            limpiarFormulario() {
                this.cliente = {
                    code: '',
                    name: '',
                    address: '',
                    loading_time_minutes: '',
                    email: '',
                    owner_empresa: null
                }
                this.empresas = []
                this.searchEmpresa = null
                this.valid = false
            },
            clear: function () {
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
            },
            customFilter (item, queryText) {
                const textOne = item.name.toLowerCase()
                const searchText = queryText.toLowerCase()
                return textOne.indexOf(searchText) > -1
            }
        }
    }
</script>
